export interface RoyalChallengeHallAsset {
  readonly key: string;
  readonly path: string;
  readonly width: number;
  readonly height: number;
  readonly kind: 'image';
  readonly alpha: boolean;
  readonly required: true;
}

const ROOT = 'assets/number-kingdom/royal-challenge-hall';
const image = (
  key: string,
  path: string,
  width: number,
  height: number,
  alpha: boolean,
): RoyalChallengeHallAsset => ({ key, path: `${ROOT}/${path}`, width, height, kind: 'image', alpha, required: true });

export const ROYAL_CHALLENGE_HALL_ASSETS = {
  dormant: image('royal-challenge-hall-dormant', 'backgrounds/royal-challenge-hall-dormant.png', 1280, 720, false),
  restored: image('royal-challenge-hall-restored', 'backgrounds/royal-challenge-hall-restored.png', 1280, 720, false),
  masteryCrest: image('royal-challenge-hall-mastery-crest', 'vfx/mastery-crest-glow.png', 384, 384, true),
} as const;

export const ROYAL_CHALLENGE_HALL_ASSET_LIST = Object.values(ROYAL_CHALLENGE_HALL_ASSETS);

// Browser/responsive/console QA must pass before the route is exposed.
export const ROYAL_CHALLENGE_HALL_PRODUCTION_READY = true;

export function preloadRoyalChallengeHallAssets(scene: Phaser.Scene) {
  ROYAL_CHALLENGE_HALL_ASSET_LIST.forEach(asset => scene.load.image(asset.key, asset.path));
}

export function getMissingRoyalChallengeHallAssets(textures: Phaser.Textures.TextureManager) {
  return ROYAL_CHALLENGE_HALL_ASSET_LIST.filter(asset => !textures.exists(asset.key));
}

export function canEnterRoyalChallengeHall(textures: Phaser.Textures.TextureManager) {
  return ROYAL_CHALLENGE_HALL_PRODUCTION_READY
    && getMissingRoyalChallengeHallAssets(textures).length === 0;
}
